import "./LuogoPage.css";
import { t } from "../../../services/formatters";
import { useLuogoPage } from "./useLuogoPage";
import { TextInput } from "../../../components/TextInput";
import { Button } from "../../../components/Button";
import { ErrorModal } from "../../../components/ErrorModal";
import { EditAppointmentModal } from "../../../components/EditAppointmentModal";
import { Suggestions } from "../../../components/Suggestions";
import { useEffect } from "react";

export const LuogoC5Page = () => {
    const {
        next,
        nextPP,
        onLuogoChange,
        onLuogoBlur,
        onSuggestionClick,
        suggestions,
        read,
        update,
        onGeoClick,
        isFetchFilialiStart,
        isFetchFilialiWaiting,
        isFetchPositioEnd,
        getSearchInputState,
        fetchErrorMessage,
        fetchError,
        setFetchError,
        showModal,
        closeModal,
        askForEditAppointment,
        isLoading,
        setPrestitoBusiness,
        setPrestitoPersonale,
    } = useLuogoPage();

    useEffect(() => {
        window.dataLayer.push({
            event: "customPageview",
            virtualPageURL: "/fa3/c5/fissa-appuntamento/cerca-agenzia",
            funnelVersion: "nuovo",
            FA_funnel: "Cessione del quinto",
            crmIdentification: "nuovo utente",
        });
    }, []);

    return (
        <>
            {isLoading && <div id="start-overlay">Attendere...</div>}

            {!isLoading && (
                <div id="luogo-page">
                    <div className={`section page-title-component center-on-tablet`}>
                        <h1 dangerouslySetInnerHTML={{ __html: t("fissa_quiC5") }}></h1>
                        {/* <div>{t("basta_un_giorno")}</div> */}
                    </div>

                    <div className={`section white-box input-box-component`}>
                        <h2>{t("dove_appuntamentoC5")}</h2>
                        <p className={`input-box-subtitle`}>&nbsp;</p>
                        <TextInput
                            isGeo={true}
                            name="cap"
                            placeholder={t("inserisci_cap")}
                            value={read("luogo")}
                            onChange={onLuogoChange}
                            onBlur={onLuogoBlur}
                            onIconClick={onGeoClick}
                            state={getSearchInputState()}></TextInput>
                        <Suggestions suggestions={suggestions} onSuggestionClick={onSuggestionClick} />

                        {isFetchPositioEnd() ? <small style={{ color: "#5DBFAB" }}>Ottimo! Abbiamo trovato una filiale vicino a te!</small> : ""}
                    </div>

                    <div className="section text-center">
                        <Button
                            id="go-to-select-state-btn"
                            disabled={!isFetchFilialiStart()}
                            onClick={() => {
                                if (read("prodotto") == 3) {
                                    next();
                                } else {
                                    //Non erano presenti filiali C5, rimando a PP
                                    nextPP();
                                }
                            }}
                            classList="btn-responsive always-style"
                            loading={isFetchFilialiWaiting()}
                            text={t("avanti")}
                        />
                    </div>

                    <div className="external-products-footer-component">
                        <p id="or-text" className="text-center">
                            {t("oppure")}
                        </p>

                        <div className="section flex-row centered-content text-center">
                            <h4 className="flex-cell clickable">
                                <a
                                    onClick={() => {
                                        window.location.host.indexOf("compassquinto") != -1 ? (window.location.href = "https://www.compass.it/fa3/") : setPrestitoPersonale();
                                    }}
                                    className="hide-tablet hide-desktop"
                                    aria-roledescription="link"
                                    aria-label={t("finanziamento_standard")}
                                    dangerouslySetInnerHTML={{ __html: t("finanziamento_standard") }}></a>
                                <a
                                    onClick={() => {
                                        window.location.host.indexOf("compassquinto") != -1 ? (window.location.href = "https://www.compass.it/fa3/") : setPrestitoPersonale();
                                    }}
                                    className="hide-mobile"
                                    aria-roledescription="link"
                                    aria-label={t("finanziamento_standard")}
                                    dangerouslySetInnerHTML={{
                                        __html: t("finanziamento_standard"),
                                    }}></a>
                            </h4>
                            <h4 className="flex-cell clickable">
                                <a
                                    onClick={setPrestitoBusiness}
                                    className="hide-tablet hide-desktop"
                                    aria-roledescription="link"
                                    aria-label={t("finanziamento_business")}
                                    dangerouslySetInnerHTML={{ __html: t("finanziamento_business") }}></a>
                                <a
                                    onClick={setPrestitoBusiness}
                                    className="hide-mobile"
                                    aria-roledescription="link"
                                    aria-label={t("finanziamento_business")}
                                    dangerouslySetInnerHTML={{
                                        __html: t("finanziamento_business_tablet"),
                                    }}></a>
                            </h4>
                        </div>

                        {/* Edit appto link */}
                        <div className="section text-center bottom-area">
                            <div className={`section edit-appointment-link-component text-uppercase color-text-primary clickable`} onClick={askForEditAppointment}>
                                {t("modifica_appuntamento_gia_fissato")}
                            </div>
                        </div>
                    </div>

                    <ErrorModal
                        open={fetchError}
                        text={fetchErrorMessage}
                        onCloseModal={() => {
                            setFetchError(false);
                        }}></ErrorModal>

                    <EditAppointmentModal
                        open={showModal}
                        title={t("modifica_appuntamento")}
                        text={read("codiceFiscale") ? t("modifica_appuntamento_esistente") : t("modifica_appuntamento_esistente_unknown")}
                        onCloseModal={closeModal}></EditAppointmentModal>
                </div>
            )}
        </>
    );
};
